<script setup>
    // It's the Search fields themselves! The search must be implemented/executed in the parent component.

    import { ref } from 'vue';

    const props = defineProps(['fields']);
    defineEmits(['filters']);

    const returnFields = ref(props.fields);

</script>

<template>
    <div class="data-table">
        <div class="filter-table">
            <p>Mit den folgenden Suchfeldern können Sie die Ergebnisse der Tabelle unterhalb filtern.</p>
            <div class="filters">
                <form @submit.prevent>
                    <div class="form-group row" v-for="field in returnFields" :key="field.id">
                        <label class="col-sm-3 col-form-label" :for="field.index">{{ field.title }}</label>
                        <div class="col-sm-9" >
                            <input class="form-control" type="text" v-model="field.value" :id="field.index">
                        </div>
                    </div>
                    <div class="d-grid gap-2">
                        <button class="btn btn-primary col-sm-3" type="submit" @click="$emit('filters', returnFields)">Suchen</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>
